import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../../../config/queryClient'
import { QuoteState } from '../../../enums/quoteState'
import { fetchQuotes } from '../../../query-api'
import { QuotesQueryProps } from '../../../types/quotesQueryProps'
import { getQuotesQueryKey } from '../../../utils/getQuotesQueryKey'

export interface UseIsQuotesListEmptyResult {
  isLoading: boolean
  isQuotesListEmpty: boolean
}

export const useIsQuotesListEmpty = (): UseIsQuotesListEmptyResult => {
  const { organization } = useUserOrganization()

  const queryProps: QuotesQueryProps = useMemo(
    () => ({
      page: 1,
      pageSize: 1 as ItemsPerPage,
      state: QuoteState.All,
      organization: organization?.id as string,
    }),
    [organization],
  )

  const queryKey = useMemo(() => getQuotesQueryKey(queryProps), [queryProps])

  const { data: quotesCountData, isFetched: quotesCountFetched } = useQuery(queryKey, () => fetchQuotes(queryProps), {
    enabled: !!organization,
    staleTime: defaultStaleTime,
  })

  return {
    isLoading: !quotesCountFetched,
    isQuotesListEmpty: quotesCountFetched && quotesCountData?.data.length === 0,
  }
}
